import {Polyline, useMap} from "@vis.gl/react-google-maps";
import {useEffect} from "react";
import {useSpiderfy} from "../../../../../../hooks/use-spiderfier-adv-marker.js";
import NetworkMarker from "./network-marker.jsx";

const NetworkMarkers = ({baseMarkers, activeMarker, onSelect, onClear}) => {
    const map = useMap();
    const {markers, toggleSpiderfy, setSpiderState} = useSpiderfy(baseMarkers, map);

    useEffect(() => {
        if (!map) return;

        const listener = map.addListener("click", () => {
            setSpiderState(null);
            onClear();
        });

        return () => listener.remove();
    }, [map]);

    const handleClick = (marker) => {
        const result = toggleSpiderfy(marker);

        if (result?.type === "spiderfy") {
            onClear();
        } else {
            onSelect(marker);
        }
    };

    return (
        <>
            {markers.map((marker) => (
                <NetworkMarker
                    key={marker.id}
                    marker={marker}
                    isSelected={marker.id === activeMarker?.id}
                    onClick={() => handleClick(marker)}
                />
            ))}
            {markers.map((marker) => {
                if (!marker.original) return null;

                return (
                    <Polyline
                        key={`line-${marker.id}`}
                        path={[marker.original, {lat: marker.lat, lng: marker.lng}]}
                        strokeColor={"#000"}
                        strokeOpacity={0.7}
                        strokeWeight={2}
                    />
                );
            })}
        </>
    );
};

export default NetworkMarkers;
